export default {
  notConnected: 'Wallet Not Connected',
  connectWallet: 'Connect Wallet',
  connected: 'Wallet Connected',
  disconnected: 'Disconnected',
  address: 'Address',
  network: 'Network',
  status: 'Status',
  fullAddress: 'Full Address',
  chainId: 'Chain ID',
  connectionTime: 'Connection Time',
  walletType: 'Wallet Type',
  copyAddress: 'Copy Address',
  viewOnChain: 'View on Chain',
  connectionFailed: 'Connection Failed',
  reconnect: 'Reconnect',
  disconnect: 'Disconnect',
  connectionStatus: {
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting',
    error: 'Connection Error'
  },
  connect: {
    title: 'Connect Your Wallet',
    description: 'Choose a wallet to connect to PrivacyChain',
    detected_wallet: 'Detected Wallet',
    connect: 'Connect',
    install: 'Install',
    connecting: 'Connecting...',
    instructions: {
      title: 'How to Connect',
      support: 'Supported wallets: MetaMask, Binance Wallet, Phantom, Coinbase Wallet, Trust Wallet and more',
      secure: 'Your wallet connection is secure and only you have access',
      auto_detect: 'We automatically detect installed wallets in your browser',
      quick_connect: 'Simply click Connect and approve in your wallet'
    }
  },
  detected: {
    wallets: 'Detected Wallets'
  },
  descriptions: {
    metamask: 'The most popular Web3 wallet',
    binance: 'Official Binance exchange wallet',
    imtoken: 'Multi-chain mobile wallet',
    bitget: 'Bitget exchange wallet',
    okx: 'OKX exchange wallet',
    tokenpocket: 'Multi-chain Web3 wallet',
    coinbase: 'Coinbase exchange wallet',
    trust: 'Trust Wallet - secure mobile wallet',
    rainbow: 'Rainbow Wallet - beautiful Web3 wallet',
    brave: 'Built-in wallet in Brave browser',
    phantom: 'Solana blockchain wallet',
    generic: 'Generic Web3 compatible wallet'
  }
};
